import Timer from './Timer.component'

export default Timer
